import { render, staticRenderFns } from "./taskPurchaseOrderPickupDataTable.vue?vue&type=template&id=d660f9fa&"
import script from "./taskPurchaseOrderPickupDataTable.vue?vue&type=script&lang=js&"
export * from "./taskPurchaseOrderPickupDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports